module.exports = __webpack_public_path__ + "static/media/arrow.00557fd0.svg";